import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import type { IconType } from 'react-icons';
import { content } from '@/content/content';
import type { SocialKey } from '@/content/content';

const icons: Record<SocialKey, IconType> = {
    email: FaEnvelope,
    linkedin: FaLinkedin,
    github: FaGithub,
};

const socialOrder: SocialKey[] = ['email', 'linkedin', 'github'];

const Footer = (): JSX.Element => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="relative z-10 mt-24 border-t border-[color:var(--hairline)]">
            <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 py-8 sm:flex-row sm:justify-between sm:px-8">
                <p className="text-center font-mono text-xs tracking-[0.08em] text-[color:var(--fg-muted)] sm:text-left">
                    © {currentYear} {content.nav.brand} · {content.footer.tagline}
                </p>
                <nav aria-label="Social links" className="flex items-center gap-5">
                    {socialOrder.map((key) => {
                        const { url, label } = content.social[key];
                        const Icon = icons[key];
                        const external = key !== 'email';
                        return (
                            <a
                                key={key}
                                href={url}
                                aria-label={label}
                                title={label}
                                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                                className="rounded text-[color:var(--fg-muted)] transition-colors hover:text-primary-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-dark active:scale-95 dark:hover:text-primary dark:focus-visible:ring-primary"
                            >
                                <Icon size="1.3rem" aria-hidden="true" />
                            </a>
                        );
                    })}
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
